import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import React from 'react'

type SubscriptionAvatarProps = {
  publicName: string | null
  email: string | null
}

export function SubscriptionAvatar({ publicName, email }: SubscriptionAvatarProps) {
  return (
    <div className="flex items-center space-x-2">
      <Avatar>
        <AvatarFallback>
          {publicName
            ?.split(' ')
            .filter(Boolean)
            .map((part) => part[0])
            .slice(0, 2)
            .join('')
            .toUpperCase()}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="font-semibold">{publicName}</span>
        {/*<span className="text-sm text-muted-foreground">{email}</span>*/}
      </div>
    </div>
  )
}
